import styled from 'styled-components';

export const HorizontalLine = styled.hr`
    display: block;
    height: 1px;

    border: 0;
    border-top: 1px solid ${({theme}) => theme.colors.monochrome.seven};
`;
